import { cx } from "@/utils/cx";

export type BuilderDragPreviewProps =
	| {
			variant: "palette";
			label: string;
	  }
	| {
			variant: "field";
			label: string;
			typeLabel: string;
			required?: boolean;
	  }
	| {
			variant: "section";
			title: string;
			subtitle: string;
	  };

const shellClass =
	"max-w-sm rounded-lg border border-border-secondary bg-background-primary p-3 shadow-lg ring-1 ring-border-secondary/60";

/**
 * Floating preview for the form builder `DragOverlay` while dragging.
 */
export function BuilderDragPreview(props: BuilderDragPreviewProps) {
	if (props.variant === "palette") {
		return (
			<div className={cx(shellClass, "opacity-95")}>
				<span className="text-sm font-medium text-text-primary">
					{props.label}
				</span>
			</div>
		);
	}

	if (props.variant === "section") {
		return (
			<div className={cx(shellClass, "opacity-95")}>
				<div className="font-semibold text-text-primary">{props.title}</div>
				<div className="text-sm text-text-tertiary">{props.subtitle}</div>
			</div>
		);
	}

	return (
		<div
			className={cx(
				shellClass,
				"flex items-start gap-2 opacity-95",
				"border-border-secondary",
			)}
		>
			<div className="min-w-0 flex-1">
				<div className="font-semibold text-text-primary">
					{props.label}
					{props.required ? (
						<span className="text-error-600" aria-hidden>
							{" "}
							*
						</span>
					) : null}
				</div>
				<div className="text-sm text-text-tertiary">{props.typeLabel}</div>
			</div>
		</div>
	);
}
